import React from 'react';
import { FilterBar, FilterDefinition } from './common/FilterControls';

export interface InvoiceFiltersState {
  dateRange: { start_date: string; end_date: string };
  invoice_number?: string;
  customer?: string;
  sales_person?: string;
  sales_lead?: string;
  purchase_order?: string;
  status?: string;
  voided?: string;
  has_attachments?: string;
  has_valid_po?: string;
  has_vp_waiver?: string;
  has_valid_invoice?: string;
  has_parse_errors?: string;
}

interface InvoiceFilterBarProps {
  filters: InvoiceFiltersState;
  onFiltersChange: (filters: InvoiceFiltersState) => void;
  onClearFilters: () => void;
}

const filterDefs: FilterDefinition[] = [
  { type: 'text', field: 'invoice_number', label: 'Invoice #', icon: 'bi-receipt', placeholder: 'Filter by invoice number...' },
  { type: 'text', field: 'customer', label: 'Customer', icon: 'bi-building', placeholder: 'Filter by customer name...' },
  { type: 'text', field: 'sales_person', label: 'Sales Person', icon: 'bi-person', placeholder: 'Filter by salesperson...' },
  { type: 'text', field: 'sales_lead', label: 'Sales Lead', icon: 'bi-person-badge', placeholder: 'Filter by sales lead...' },
  { type: 'text', field: 'purchase_order', label: 'PO #', icon: 'bi-cart', placeholder: 'Filter by purchase order...' },
  {
    type: 'select', field: 'status', label: 'Status', icon: 'bi-check-circle',
    options: [
      { value: 'NotDue', label: 'Not Due' },
      { value: 'OverDue', label: 'Overdue' },
      { value: 'PaidInFull', label: 'Paid' },
      { value: 'OverPaid', label: 'Overpaid' },
      { value: 'Voided', label: 'Voided' },
    ],
  },
  {
    type: 'select', field: 'voided', label: 'Voided', icon: 'bi-slash-circle',
    options: [
      { value: 'include', label: 'Include' },
      { value: 'exclude', label: 'Exclude' },
      { value: 'only', label: 'Only' },
    ],
  },
  {
    type: 'select', field: 'has_attachments', label: 'Attachments', icon: 'bi-paperclip',
    options: [
      { value: 'true', label: 'Has Attachments' },
      { value: 'false', label: 'No Attachments' },
    ],
  },
  {
    type: 'select', field: 'has_valid_po', label: 'PO', icon: 'bi-file-earmark-check',
    options: [
      { value: 'true', label: 'Has PO' },
      { value: 'false', label: 'No PO' },
    ],
  },
  {
    type: 'select', field: 'has_vp_waiver', label: 'VP Waiver', icon: 'bi-shield-check',
    options: [
      { value: 'true', label: 'Has Waiver' },
      { value: 'false', label: 'No Waiver' },
    ],
  },
  {
    type: 'select', field: 'has_valid_invoice', label: 'Validated', icon: 'bi-check-square',
    options: [
      { value: 'true', label: 'Validated' },
      { value: 'false', label: 'Not Validated' },
    ],
  },
  {
    type: 'select', field: 'has_parse_errors', label: 'Errors', icon: 'bi-exclamation-triangle',
    options: [
      { value: 'true', label: 'Has Errors' },
      { value: 'false', label: 'No Errors' },
    ],
  },
];

const InvoiceFilterBar: React.FC<InvoiceFilterBarProps> = ({ filters, onFiltersChange, onClearFilters }) => {
  const handleFilterChange = (field: string, value: string | undefined) => {
    onFiltersChange({
      ...filters,
      [field]: value || undefined,
    });
  };

  return (
    <FilterBar
      filters={filters}
      filterDefs={filterDefs}
      excludeFromCount={['dateRange']}
      onFilterChange={handleFilterChange}
      onClearFilters={onClearFilters}
    />
  );
};

export default InvoiceFilterBar;
